import { FORTA_BLUE } from '../../utils/colors';

import type { IconProps } from './types';

const EllipsisIcon = (props: IconProps) => {
  const { color = FORTA_BLUE.primary } = props;
  return (
    <svg
      data-testid={props.testId}
      width="28"
      height="8"
      viewBox="0 0 28 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.99935 7.33366C3.08268 7.33366 2.29796 7.00727 1.64518 6.35449C0.992405 5.70171 0.666016 4.91699 0.666016 4.00033C0.666016 3.08366 0.992405 2.29894 1.64518 1.64616C2.29796 0.993381 3.08268 0.666992 3.99935 0.666992C4.91602 0.666992 5.70074 0.993381 6.35352 1.64616C7.00629 2.29894 7.33268 3.08366 7.33268 4.00033C7.33268 4.91699 7.00629 5.70171 6.35352 6.35449C5.70074 7.00727 4.91602 7.33366 3.99935 7.33366ZM13.9993 7.33366C13.0827 7.33366 12.298 7.00727 11.6452 6.35449C10.9924 5.70171 10.666 4.91699 10.666 4.00033C10.666 3.08366 10.9924 2.29894 11.6452 1.64616C12.298 0.993381 13.0827 0.666992 13.9993 0.666992C14.916 0.666992 15.7007 0.993381 16.3535 1.64616C17.0063 2.29894 17.3327 3.08366 17.3327 4.00033C17.3327 4.91699 17.0063 5.70171 16.3535 6.35449C15.7007 7.00727 14.916 7.33366 13.9993 7.33366ZM23.9993 7.33366C23.0827 7.33366 22.298 7.00727 21.6452 6.35449C20.9924 5.70171 20.666 4.91699 20.666 4.00033C20.666 3.08366 20.9924 2.29894 21.6452 1.64616C22.298 0.993381 23.0827 0.666992 23.9993 0.666992C24.916 0.666992 25.7007 0.993381 26.3535 1.64616C27.0063 2.29894 27.3327 3.08366 27.3327 4.00033C27.3327 4.91699 27.0063 5.70171 26.3535 6.35449C25.7007 7.00727 24.916 7.33366 23.9993 7.33366Z"
        fill={color}
      />
    </svg>
  );
};

export default EllipsisIcon;
